import { Box, Paper, Stack, Typography } from "@mui/material"
import { t } from "i18next"
import React from "react"
import { isArrayNullOrEmpty } from "../../helper/helper"
import { Organisation, QualityLevel } from "../../models/organisation/Organisation"
import { colorGrey } from "../../rsc/colors/colors"
import { ButtonCreateQualityPrices } from "./ButtonCreateQualityPrices"
import { ButtonDeleteQBP } from "./ButtonDeleteQBP"


type Props = {
  style: React.CSSProperties
  org?: Organisation
}

export function CompanyQBP({ style, org }: Props) {

  const qualityLevels: QualityLevel[] = org?.qualityLevels ?? []

  return (
    <div hidden={false} style={{ ...style, flexDirection: "column", gap: "1px" }}>
      <p className="greyColor" style={{ fontSize: "20px" }}>{t('quality_level')}</p>
      {/* <div id="groupMap"></div> */}
      <div style={{ display: "flex", gap: "15px", boxShadow: "0px -2px 6px rgba(0, 0, 0, 0.05), 0px 4px 6px rgba(0, 0, 0, 0.10)", marginTop: "10px" }}>
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: '10px',
          flex: 1
        }}>
          {
            qualityLevels.length === 0 && <p style={{ fontWeight: 600, fontStyle: 'italic', color: colorGrey, marginTop: '10px' }}>{t('no_quality_price_created')}</p>
          }
          <Box
            sx={{
              backgroundColor: "#f9f9f9",
              py: 1,
              px: 1,
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Stack spacing={1} sx={{ width: "100%" }}>
              {qualityLevels.map((item, index) => (
                <Paper
                  key={index}
                  elevation={2}
                  sx={{
                    p: 2,
                    textAlign: "center",
                    borderRadius: 2,
                    transition: "all 0.2s",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: 4,
                    },
                  }}
                >
                  <Typography variant="body1" color="textPrimary">
                    {item.name}
                  </Typography>
                </Paper>
              ))}
            </Stack>
          </Box>
          <div className="pempem-flex-row padding10">
            {
              !isArrayNullOrEmpty(org?.qualityLevels) &&
              <div className="pempem-flex-row-center" style={{ flex: 1 }}>
                <ButtonDeleteQBP org={org} />
              </div>
            }
            <div className="pempem-flex-row-center" style={{ flex: 1 }}>
              <ButtonCreateQualityPrices org={org} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}